/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CodeDTO
 */
export interface CodeDTO {
    /**
     * 
     * @type {number}
     * @memberof CodeDTO
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof CodeDTO
     */
    label: string;
}

export function CodeDTOFromJSON(json: any): CodeDTO {
    return CodeDTOFromJSONTyped(json, false);
}

export function CodeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'label': json['label'],
    };
}

export function CodeDTOToJSON(value?: CodeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'label': value.label,
    };
}

